// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__1YP-U","insightsList":"newBusinessInsightsMenu_insightsList__1yPi2","active":"newBusinessInsightsMenu_active__1X4JN"};